import { api } from '@/api/endpoints';
import { ApiException } from '@/api/client';
import { tg } from './telegram';

const LS_TOKEN = 'ia_token';
const LS_USER  = 'ia_user';

export function loadStoredToken(): string | null {
  try { return localStorage.getItem(LS_TOKEN); } catch { return null; }
}

export function persistToken(token: string | null): void {
  try {
    if (token) localStorage.setItem(LS_TOKEN, token);
    else localStorage.removeItem(LS_TOKEN);
  } catch { /* ignore */ }
}

export function persistUser<T>(user: T | null): void {
  try {
    if (user) localStorage.setItem(LS_USER, JSON.stringify(user));
    else localStorage.removeItem(LS_USER);
  } catch { /* ignore */ }
}

export function loadStoredUser<T>(): T | null {
  try {
    const raw = localStorage.getItem(LS_USER);
    return raw ? JSON.parse(raw) as T : null;
  } catch { return null; }
}

/**
 * Логинимся через Telegram initData, возвращаем токен и юзера.
 * Если initData пустой (запуск вне Telegram) — кидаем ошибку.
 */
export async function loginViaTelegram() {
  const initData = tg()?.initData ?? '';
  if (!initData) {
    throw new ApiException(0, 'no_init_data', 'Telegram WebApp unavailable');
  }
  const { data } = await api.auth.telegram(initData);
  persistToken(data.token);
  persistUser(data.user);
  return data;
}
